import { ImgHTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

type WrapperProps = {
  isDragging?: boolean;
  showCloseIcon?: boolean;
  children?: ReactNode;
  ref?: any;
};

export const Wrapper = styled.div<WrapperProps>`
  background-color: #265e9d;
  color: #fff;
  visibility: ${({ isDragging }) => (isDragging ? 'hidden' : 'visible')};
  cursor: pointer;
  font: 400 14px;
  letter-spacing: -0.065em;
  margin: 0 5px 5px;
  padding: ${({ showCloseIcon }) => (showCloseIcon ? '5px 8px 5px 14px' : '5px 17px 5px 14px')};
  white-space: nowrap;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  height: fit-content;
  width: fit-content;
`;

type IconProps = ImgHTMLAttributes<HTMLImageElement>;

export const Icon = styled.img<IconProps>`
  margin-left: 10px;
`;
